__webpack_require__.p = "/integrations-lazy/referrals-hub/";